import { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AppToastContainer, appToast } from "../components/notification/app-toast";
import AuthLayoutHoc from "../HOC/auth-layout.hoc";
import MainLayoutHoc from "../HOC/main-layout.hoc";
import Auth from "../screens/auth";
import ForgotPassword from "../screens/auth/forgot-password";
import Login from "../screens/auth/login";
import ResetPassword from "../screens/auth/reset-password";
import SetPassword from "../screens/auth/set-password";
import Signup from "../screens/auth/signup";
import AmbassadorSignup from "../screens/auth/signup/ambassador";
import MoreAboutAmbassadorCompanyForm from "../screens/auth/signup/ambassador/more-about-company";
import SignupComplete from "../screens/auth/signup/ambassador/signup-complete";
import VendorSignup from "../screens/auth/signup/vendor";
import MoreAboutVendorCompanyForm from "../screens/auth/signup/vendor/more-about-company";
import MeetingRecordings from "../screens/meeting-recordings";
import MeetingSummary from "../screens/meeting-summary";
import InvitationDecline from "../screens/my-projects/invitation-decline";
import ProjectInvitationReminder from "../screens/my-projects/invitation-reminder";
import ProjectDetailsNoAuth from "../screens/project-details/project-details-no-auth";
import RecordingViewer from "../screens/recording-viewer";
import ReviewReport from "../screens/review-report";
import Typeform from "../screens/typeform";
import { useAppDispatch, useAppSelector } from "../store";
import { hideNotification } from "../store/modules/UI";
import PageNotFound from "../templates/page-not-found";
import {
  Initiatives,
  MarketplaceProfileView,
  MyProfile,
  MyProjects,
  MySchedule,
  NewInvitationReview,
  ProjectDetails,
  Settings,
} from "./main";
import { ROUTE_PATHS } from "./paths";

function AppRoutes() {
  const {
    show = false,
    message,
    type = "success",
  } = useAppSelector((state) => state.UI.notification);
  const dispatch = useAppDispatch();

  const closeNotification = () => {
    dispatch(hideNotification());
  };

  useEffect(() => {
    message &&
      appToast.show(message, {
        type: type,
        onClose: closeNotification,
      });
  }, [message, show]);

  return (
    <>
      <AppToastContainer />
      <Routes>
        <Route path="*" element={<PageNotFound />} />
        <Route
          path={ROUTE_PATHS.HOME}
          element={<Navigate replace to={ROUTE_PATHS.AUTH.LOGIN} />}
        />
        <Route path={ROUTE_PATHS.AUTH.REDIRECT_URL} element={<Auth />} />
        <Route
          path={ROUTE_PATHS.MEETING_SUMMARY}
          element={<MeetingSummary />}
        />
        <Route
          path={ROUTE_PATHS.RECORDING_VIEWER}
          element={<RecordingViewer />}
        />
        <Route
          path={ROUTE_PATHS.PROJECT.PROJECT_DETAILS_INVITATION_ID_NO_AUTH}
          element={<ProjectDetailsNoAuth />}
        />
        <Route
          path={ROUTE_PATHS.PROJECT.INVITATION_DECLINE}
          element={<InvitationDecline />}
        />
        <Route path={ROUTE_PATHS.TYPEFORM} element={<Typeform />} />
        <Route
          path={ROUTE_PATHS.TYPEFORM_REVIEW_REPORT}
          element={<ReviewReport />}
        />
        <Route path={ROUTE_PATHS.SIGNUP_SUCCESS} element={<SignupComplete />} />

        <Route
          path={ROUTE_PATHS.MARKETPLACE_PROFILE}
          element={<MarketplaceProfileView />}
        />

        <Route element={<AuthLayoutHoc />}>
          <Route path={ROUTE_PATHS.AUTH.SIGNUP} element={<Signup />} />
          <Route path={ROUTE_PATHS.AUTH.LOGIN} element={<Login />} />
          <Route
            path={ROUTE_PATHS.AUTH.SIGNUP_AMBASSADOR}
            element={<AmbassadorSignup />}
          />
          <Route
            path={ROUTE_PATHS.AUTH.SIGNUP_VENDOR}
            element={<VendorSignup />}
          />
          <Route
            path={ROUTE_PATHS.AUTH.SIGNUP_MORE_ABOUT_VENDOR_COMPANY}
            element={<MoreAboutVendorCompanyForm />}
          />
          <Route
            path={ROUTE_PATHS.AUTH.SIGNUP_MORE_ABOUT_AMBASSADOR_COMPANY}
            element={<MoreAboutAmbassadorCompanyForm />}
          />

          <Route
            path={ROUTE_PATHS.AUTH.FORGOT_PASSWORD}
            element={<ForgotPassword />}
          />
          <Route
            path={ROUTE_PATHS.AUTH.RESET_PASSWORD}
            element={<ResetPassword />}
          />
          <Route
            path={ROUTE_PATHS.AUTH.SET_PASSWORD}
            element={<SetPassword />}
          />
        </Route>
        <Route element={<MainLayoutHoc />}>
          <Route path={ROUTE_PATHS.SCHEDULE} element={<MySchedule />} />
          <Route path={ROUTE_PATHS.MY_PROFILE} element={<MyProfile />} />
          <Route path={ROUTE_PATHS.SETTINGS} element={<Settings />} />
          <Route path={ROUTE_PATHS.INITIATIVES.LIST} element={<Initiatives />} />
          <Route
            path={ROUTE_PATHS.MEETING_RECORDINGS.LIST}
            element={<MeetingRecordings />}
          />

          <Route
            path={ROUTE_PATHS.PROJECT.LIST}
            index
            element={<MyProjects />}
          />
          <Route
            path={ROUTE_PATHS.PROJECT.PROJECT_DETAILS_INVITATION_ID}
            index
            element={<ProjectDetails />}
          />
          <Route
            path={ROUTE_PATHS.PROJECT.INVITATION_REMINDER}
            element={<ProjectInvitationReminder />}
          />
          <Route
            path={ROUTE_PATHS.PROJECT.NEW_INVITATION_REVIEW}
            element={<NewInvitationReview />}
            index
          />
        </Route>
      </Routes>
    </>
  );
}

export default AppRoutes;
